.<template>
  <div class="">
                       
    <ValidationObserver v-slot="{ handleSubmit }">
      <CForm @submit.prevent="handleSubmit(onSubmit)">
        <CCard >
          <CCardHeader class="grey-header">
            <CRow class="flex-flow-column">
              <CCol>
                <strong
                  >{{
                    selSurcharge
                      ? $t("surchargeNew.updateTitle")
                      : $t("surchargeNew.title")
                  }}
                </strong>
              </CCol>

              <p class="desc">{{ $t("surchargeNew.desc") }}</p>
            </CRow>
          </CCardHeader>
 <cPopupLoader v-if="isLoading"/>

          <CCardBody v-else-if="surcharge">
            <section>
              <div>
                <strong>
                  {{ $t("surchargeNew.surchargeDet") }}
                </strong>
              </div>
              <center>
                <CRow>
                  <cTextInputComponent
                    :label="$t('surchargeNew.name')"
                    :placeholder="$t('surchargeNew.namePh')"
                    :rules="'required|onlyAlphabets|max:100|noInitialSpace'"
                    v-model="surcharge.surchargeName"
                  >
                  </cTextInputComponent>
                </CRow>

                <CRow v-if="lsSurchargeTypes && lsSurchargeTypes.length">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :rules="'required'"
                    tag="span"
                  >
                    <div>
                      <span>
                        {{ $t("surchargeNew.type") }}
                      </span>
                    </div>

                    <multiselect
                      :allow-empty="false"
                      :showLabels="false"
                      :clearOnSelect="false"
                      v-model="surcharge.surchargeType"
                      :options="lsSurchargeTypes"
                      :multiple="false"
                      :group-select="false"
                      :placeholder="$t('surchargeNew.typePh')"
                      track-by="value"
                      label="name"
                      class="mt-auto"
                      :searchable="true"
                    >
                      <span slot="noResult"
                        ><strong>{{
                          $t("noMatchFound.noMatchFound")
                        }}</strong></span
                      >
                    </multiselect>
                    <div
                      v-if="errors && errors[0]"
                      class="invalid-feedback icon"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </CRow>
                <CRow>
                  <ValidationProvider
                    v-slot="{ errors }"
                    :rules="'required'"
                    tag="div"
                  >
                    <div>
                      <span>
                        {{ $t("surchargeNew.room") }}
                      </span>
                    </div>
                      <!-- :disabled="selSurcharge ? true : false" -->
                    <multiselect
                    
                      v-if="lsHotelRooms && lsHotelRooms.length"
                      :allow-empty="false"
                      :showLabels="false"
                      :clearOnSelect="false"
                      v-model="surcharge.roomObj"
                      :options="lsHotelRooms"
                      :multiple="false"
                      :group-select="false"
                      :placeholder="$t('surchargeNew.roomPh')"
                      track-by="roomid"
                      label="roomname"
                      class="mt-auto"
                      :searchable="true"
                      @input="onHotelRoomChange"
                    >
                      <span slot="noResult"
                        ><strong>{{
                          $t("noMatchFound.noMatchFound")
                        }}</strong></span
                      >
                    </multiselect>
                    <div
                      v-if="errors && errors[0]"
                      class="invalid-feedback icon"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </CRow>

                <CRow>
                  <ValidationProvider
                    v-slot="{ errors }"
                    :rules="'required'"
                    tag="span"
                  >
                    <div>
                      <span>
                        {{ $t("surchargeNew.ratePlan") }}
                      </span>
                    </div>
                     <!-- :disabled="selSurcharge ? true : false" -->
                    <multiselect
                     
                      v-if="lsRatePlans && lsRatePlans"
                      :allow-empty="false"
                      :showLabels="false"
                      :clearOnSelect="false"
                      v-model="surcharge.ratePlan"
                      :options="lsRatePlans"
                      :multiple="false"
                      :group-select="false"
                      :placeholder="$t('surchargeNew.ratePlanPh')"
                      track-by="id"
                      label="name"
                      class="mt-auto"
                      :searchable="true"
                    >
                      <template #noOptions>
                        <div>
                          <span>
                            {{
                              surcharge.roomObj
                                ? $t("surchargeNew.noPlans")
                                : $t("surchargeNew.noRoom")
                            }}
                          </span>
                        </div>
                      </template>
                      <span slot="noResult"
                        ><strong>{{
                          $t("noMatchFound.noMatchFound")
                        }}</strong></span
                      >
                    </multiselect>
                    <div
                      v-if="errors && errors[0]"
                      class="invalid-feedback icon"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </CRow>
              </center>
            </section>

            <section>
              <div>
                <strong>
                  {{ $t("surchargeNew.appDays") }}
                </strong>
              </div>
              <center>
                <CRow>
                  <CCol col="3">
                    <span>
                      {{ $t("surchargeNew.val") }}
                    </span>
                  </CCol>
                  <CCol>
                    <div class="ext-date-wrapper box-shadow left">
                      <v-md-date-range-picker
                        :ref="''"
                        :autoApply="true"
                        :showYearSelect="true"
                        :allowPastPresets="false"
                        :disableBefore="new Date().toString()"
                        @change="onChangeDate"
                      >
                        <template slot="input">
                          <datePickerInput
                            :fromDate="
                              surcharge.stayFrom ? surcharge.stayFrom : null
                            "
                            :toDate="surcharge.stayTo ? surcharge.stayTo : null"
                            :fromLabel="$t('surchargeNew.fromDate')"
                            :toLabel="$t('surchargeNew.toDate')"
                          />
                        </template>
                      </v-md-date-range-picker>
                       <span class="input-group-btn tooltipIconAlign d-flex ai-center right-pa-icon" >  
                <img src="@imgPath/img/svg/icons/help.svg" alt=""  width="15px"  v-c-tooltip.hover="{
                              content:$t('hotelInfo.datePickerToolTip'),
                            }" >                  

              </span>
                    </div>
                  </CCol>
                </CRow>

                <CRow>
                  <div v-if="surcharge.applicableDays"
                    class="d-flex justify-content-end align-item-center button-day-partten pl-15px "
                  >
                    <!-- :rules="'required'" -->
                    <cWeekDays @onDaysSelection='onDaysSelect' :selDays.sync='surcharge.applicableDays'>

                    </cWeekDays>

                    <!-- <CRow v-if="lsWeekDays">
                      <ValidationProvider
                        v-slot="{ errors }"
                        :rules="'required'"
                        tag="div"
                      >
                        <CCol v-model="surcharge.applicableDays" col="3">
                          <span style="white-space: nowrap;">
                            {{ $t("surchargeNew.week") }}
                          </span>
                        </CCol>
                        <CCol style="white-space: nowrap;" col="9">
                          <span
                            :class="{
                              active: surcharge.applicableDays.includes(
                                weekDays
                              ),
                            }"
                            @click.stop="onDaysSelect(weekDays)"
                            v-for="(weekDays, index) in lsWeekDays"
                            :key="index + 'week'"
                            :style="{
                              color: surcharge.applicableDays.includes(weekDays)
                                ? 'blue'
                                : '',
                            }"
                            class="mr-10px min-w-45 "
                          >
                            {{ weekDays }}
                          </span>
                          <div
                            v-if="errors && errors[0]"
                            class="invalid-feedback icon"
                          >
                            {{ errors[0] }}
                          </div>
                        </CCol>
                      </ValidationProvider>
                    </CRow> -->
                  </div>
                </CRow>
                <CRow> </CRow>
              </center>
            </section>

            <section>
              <div>
                <strong>
                  {{ $t("surchargeNew.surValue") }}
                </strong>
              </div>
              <center>
                <CRow>
                  <label for="FIXED">
                    <input
                      name="adultPriceType"
                      type="radio"
                      id="FIXED"
                      :value="SURCHARGE_PRICING.FIXED"
                      v-model="surcharge.pricingType"
                    />
                    {{ $t("surchargeNew.fixed") }}
                  </label>
                  <label for="PERCENTAGE">
                    <input
                      name="adultPriceType"
                      type="radio"
                      id="PERCENTAGE"
                      :value="SURCHARGE_PRICING.PERC"
                      v-model="surcharge.pricingType"
                    />
                    {{ $t("surchargeNew.perc") }}
                  </label>
                </CRow>
                <CRow>
                  <CCol>
                    <span>
                      {{ $t("surchargeNew.amount") }}
                    </span>
                  </CCol>
                  <CCol v-if="surcharge.pricingType == SURCHARGE_PRICING.FIXED">
                    <cCurrencyDropDown
                      :selValue="surcharge.currency"
                      :ctrlName="'code'"
                      :ctrlCode="'code'"
                      :isShowCode="true"
                      :isMultiple="false"
                      :isSearchable="true"
                      v-model="surcharge.currency"
                      :url="getCurrencyServiceURL()"
                      :rules="'required'"
                      :defaultCurrencyCode="hotelObj.currency"
                    />
                  </CCol>
                  <CCol>
                    <div
                      class="input-group  flex-flow-row d-flex wrapper-prepend"
                    >
                      <div
                        v-if="
                          surcharge.currency &&
                            surcharge.pricingType == SURCHARGE_PRICING.FIXED
                        "
                        class="input-group-prepend align-curr"
                      >
                        <div></div>

                        <span class="input-group-text">{{
                          surcharge.currency.code
                        }}</span>
                      </div>

                      <cTextInputComponent
                        :placeholder="
                          surcharge.pricingType == SURCHARGE_PRICING.PERC
                            ? $t('surchargeNew.percPh')
                            : $t('surchargeNew.amountPh')
                        "
                        :rules="
                          'required|onlynumber|validDecimal' +
                            (surcharge.pricingType == SURCHARGE_PRICING.PERC
                              ? '|max_value:100'
                              : '')
                        "
                        v-model="surcharge.surchargeValue"
                      >
                      </cTextInputComponent>
                      <div class="input-group-append align-curr">
                        <div></div>

                        <span
                          v-if="surcharge.pricingType == SURCHARGE_PRICING.PERC"
                          class="input-group-text"
                          >{{ "%" }}</span
                        >
                      </div>
                    </div>
                  </CCol>
                </CRow>

                <CRow> </CRow>
              </center>
            </section>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-end" v-if="!isLoading">
            <div class="main-cta-btn">
              <CButton
                @click.stop="onSurchargeFormCancel()"
                color="danger"
                class="action-c-btn"
              >
                <img src="@imgPath/img/svg/icons/close.svg" />
                {{ $t("surchargeNew.cancel") }}
              </CButton>
              <CButton
                col="12"
                type="submit"
                color="success removewrap"
                class="action-c-btn"
              >
                <img src="@imgPath/img/svg/icons/correct.svg" />
                {{
                  selSurcharge
                    ? $t("surchargeNew.update")
                    : $t("surchargeNew.create")
                }}
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CForm>
    </ValidationObserver>

    <cAlertModal
      v-if="showConfirmModal"
      :show="showConfirmModal"
      :buttonList="getConfirmModalButtons()"
      :status="2"
      :isShowIcon="true"
      :desc="$t('surchargeNew.confirmDesc')"
    >
    </cAlertModal>
    <cAlertModal
      v-if="showSuccModal"
      :show="showSuccModal"
      :buttonList="getSuccModalButtons()"
      :status="1"
      :isShowIcon="true"
      :desc="
        selSurcharge
          ? $t('surchargeNew.updateDesc')
          : $t('surchargeNew.succDesc')
      "
    >
    </cAlertModal>
  </div>
</template>

<script>
import cReviewHotel from "../../../../components/hms/cReviewHotel";
import {
  COMPONENT_NAME,
  DATE_TIME_FORMAT,
  PATHNAME,
  SURCHARGE_TYPES,
  DEFAULT_DROPDOWN_STATUS,
} from "../../../../util/constants";
import Logger from "../../../../services/logger";
import multiselect from "vue-multiselect";
import BaseConfiguration from "../../../../config/base.js";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  cloneDeep,
  cloneData,
  showSuccessToast
} from "../../../../util/util";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES,
} from "../../../../config/API_DATA";
import apiGetHotelRooms from "../../../../services/apiGetHotelRooms";
import cTextInputComponent from "../../../../components/form/cTextInputComponent";
import cWeekDays from '../../../../components/form/cWeekDays'
import cAlertModal from "../../../../components/form/cAlertModal";
import apiGetRatePlan from "../../../../services/apiGetRatePlan";
import apiCreateSurcharge from "../../../../services/apiCreateSurcharge";
import apiUpdateSurcharge from "../../../../services/apiUpdateSurcharge";
import cRoomTypeInfo from "../../../../components/hms/manage/hotelInfo/cRoomTypeInfo";

import apiUpdateRatePlanStatus from "../../../../services/apiUpdateRatePlanStatus";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import datePickerInput from "../../../../components/datePicker/datePickerInput";
import { VMdDateRangePicker } from "material-vue-date-picker";

import cCurrencyDropDown from "../../../../components/currency/cCurrencyDropDown.vue";
import { goBack, navigate } from "../../../../router";
import { addDays } from "../../../../util/date/dateFunctions";

import cHelpTip from "../../../../components/cHelpTip.vue";

import cStatusButton from "../../../../components/form/cStatusButton.vue";
import cPopupLoader from "../../../../components/cPopupLoader";

export default {
  name: COMPONENT_NAME.C_SURCHARGE_SETUP,

  components: {
    cReviewHotel,
    cStatusButton,
    cWeekDays,
    multiselect,
    cAlertModal,
    datePickerInput,
    VMdDateRangePicker,
    ValidationObserver,
    ValidationProvider,
    cHelpTip,
    cCurrencyDropDown,
    cRoomTypeInfo,
    cTextInputComponent,
    cPopupLoader
  },
  data: () => {
    return {
      showConfirmModal: false,
      showSuccModal: false,

      lsHotelRooms: [],
    
      lsSurchargeTypes: [],
      lsRatePlans: [],
      surcharge: {
        surchargeName: null,
        ratePlan: null,
        roomObj: null,
        currency: null,
        surchargeValue: null,
        surchargeType: null,
        pricingType: "FIXED",
        stayFrom: null,
        stayTo: null,
        applicableDays: null,
      },
      isLoading:true,
    };
  },
  computed: {
    ...mapGetters("shmsManage", {
      SURCHARGE_PRICING: "GET_SURCHARGE_PRICING",
    }),

    ...mapGetters("shmsManage", {
      hotelObj: "GET_SEL_HOTEL",
    }),
    ...mapGetters("sHotelInfo", {
      selSurcharge: "GET_SEL_SURCHARGE",
    }),
  },

  methods: {
    onSurchargeFormCancel() {
      try {
        if (BaseConfiguration.isDebug) console.log("onSurchargeFormCancel");

        this.$emit("onSurchargeFormCancel");
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in onSurchargeFormCancel",
          err.toString(),
          "onSurchargeFormCancel",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async onSubmit() {
      try {
        if (BaseConfiguration.isDebug) console.log("onSubmit");
        let createdRes;
        let updatedRes;
         let toastMsg;

        if (this.selSurcharge) {
          updatedRes = await this.updateSurcharge();
          toastMsg= this.$t('surchargeNew.updateDesc')
        } else {
          createdRes = await this.createSurcharge();
          toastMsg= this.  $t('surchargeNew.succDesc')
        }

        if (
          (createdRes && createdRes.surchargeid) ||
          (updatedRes && updatedRes.isUpdated)
        ) {

        
              showSuccessToast(toastMsg);
        //  this.toggleSuccModal();

          this.$emit("onSurchargeFormSave");
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in onSubmit",
          err.toString(),
          "onSubmit",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    navToHotelInfo() {
      try {
        if (BaseConfiguration.isDebug) console.log("navToHotelInfo");

        goBack();
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in navToHotelInfo",
          err.toString(),
          "navToHotelInfo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getSuccModalButtons() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getSuccModalButtons");

        retValue = [
          {
            name: this.$t("surchargeNew.Ok"),
            func: this.navToHotelInfo,
          },
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in getSuccModalButtons",
          err.toString(),
          "getSuccModalButtons",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }

      return retValue;
    },

    getConfirmModalButtons() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getConfirmModalButtons");

        retValue = [
          {
            name: this.$t("surchargeNew.stay"),
            func: this.toggleConfirmModal,
          },
          {
            name: this.$t("surchargeNew.leave"),
            func: this.navToHotelInfo,
          },
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in getConfirmModalButtons",
          err.toString(),
          "getConfirmModalButtons",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toggleConfirmModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleConfirmModal");

        //  this.showConfirmModal = !this.showConfirmModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in toggleConfirmModal",
          err.toString(),
          "toggleConfirmModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    toggleSuccModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleSuccModal");

        this.showSuccModal = !this.showSuccModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in toggleSuccModal",
          err.toString(),
          "toggleSuccModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async updateSurcharge() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateSurcharge");

        if (this.hotelObj) {
          let surchargeReq = apiUpdateSurcharge.buildRequest(
            cloneDeep(this.surcharge),
            this.hotelObj.hotelid,
            this.SURCHARGE_PRICING
          );

          if (surchargeReq) {
            let surchargeRes = await apiUpdateSurcharge.getResponse(
              surchargeReq
            );

            if (VALIDATE_SUCCESS_RES(surchargeRes)) {
              retValue = surchargeRes.data.data;
            } else {
              let error = getErrorMessage(surchargeRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid hotel  obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in updateSurcharge",
          err.toString(),
          "updateSurcharge",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async createSurcharge() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("createSurcharge");

        if (this.hotelObj) {
          let surchargeReq = apiCreateSurcharge.buildRequest(
            cloneDeep(this.surcharge),
            this.hotelObj.hotelid,
            this.SURCHARGE_PRICING
          );

          if (surchargeReq) {
            let surchargeRes = await apiCreateSurcharge.getResponse(
              surchargeReq
            );

            if (VALIDATE_SUCCESS_RES(surchargeRes)) {
              retValue = surchargeRes.data.data;
            } else {
              let error = getErrorMessage(surchargeRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid hotel  obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in createSurcharge",
          err.toString(),
          "createSurcharge",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async onHotelRoomChange(pHotelRoomObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("onHotelRoomChange");

        if (
          pHotelRoomObj &&
          pHotelRoomObj.roomname == DEFAULT_DROPDOWN_STATUS.ALL
        ) {
          this.lsRatePlans = [{ id: null, name: DEFAULT_DROPDOWN_STATUS.ALL }];
        } else if (pHotelRoomObj) {
          let ratePlanRes = await this.getRatePlan(
            this.hotelObj.hotelid,
            pHotelRoomObj.roomid
          );
          if (ratePlanRes) {
            this.lsRatePlans = ratePlanRes.list;
            this.surcharge.ratePlan = null;
          }
        } else {
          throw " invalid hotel room obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in onHotelRoomChange",
          err.toString(),
          "onHotelRoomChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onDaysSelect(pWeekDays) {
      try {
        if (BaseConfiguration.isDebug) console.log("onDaysSelect");


        if(pWeekDays && pWeekDays.length)
        {
          this.surcharge.applicableDays  =pWeekDays
        }
        else
        {
          this.surcharge.applicableDays=[]
        }

  
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in onDaysSelect",
          err.toString(),
          "onDaysSelect",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    setValidity(pSurcharge) {
      try {
        if (BaseConfiguration.isDebug) console.log("setValidity");

        pSurcharge.stayFrom = this.$options.filters.formatDate(
          new Date(),
          DATE_TIME_FORMAT.API_DATE_FORMAT
        );
        pSurcharge.stayTo = this.$options.filters.formatDate(
          addDays(new Date(), 7),
          DATE_TIME_FORMAT.API_DATE_FORMAT
        );
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in setValidity",
          err.toString(),
          "setValidity",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getRatePlan(pHotelId, pRoomId) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getRatePlan");
        if (pHotelId && pRoomId) {
          let hotelRatePlansReq = apiGetRatePlan.buildRequest(
            pHotelId,
            pRoomId
          );

          if (hotelRatePlansReq) {
            // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
            let hotelRatePlansRes = await apiGetRatePlan.getResponse(
              hotelRatePlansReq
            );

            if (VALIDATE_SUCCESS_RES(hotelRatePlansRes)) {
              //this.showAlert(null);
              retValue = hotelRatePlansRes.data.data;
            } else {
              let error = getErrorMessage(hotelRatePlansRes);
              //  this.showAlert(error);
              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw " invalid hotelObj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in getRatePlan",
          err.toString(),
          "getRatePlan",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    onChangeDate(pDateList) {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangeDate");
        //  console.error(pDateList)
        //    this.fromDate=pDateList[0]._d;

        if (pDateList) {
          this.surcharge.stayFrom = this.$options.filters.formatDate(
            pDateList[0]._d,
            DATE_TIME_FORMAT.API_DATE_FORMAT
          );
          this.surcharge.stayTo = this.$options.filters.formatDate(
            pDateList[1]._d,
            DATE_TIME_FORMAT.API_DATE_FORMAT
          );
        }
        //  this.toDate=pDateList[1]._d;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in onChangeDate",
          err.toString(),
          "onChangeDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getCurrencyServiceURL() {
      if (BaseConfiguration.isDebug) console.log("getCurrencyServiceURL");
      return SERVICE_URL.GET_CURRENCY_LIST;
    },

    async getHotelRooms() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getHotelRooms");
        if (this.hotelObj) {
          let hotelRoomsReq = apiGetHotelRooms.buildRequest(
            this.hotelObj.hotelid
          );

          if (hotelRoomsReq) {
            // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
            let hotelRoomsRes = await apiGetHotelRooms.getResponse(
              hotelRoomsReq
            );

            if (VALIDATE_SUCCESS_RES(hotelRoomsRes)) {
              retValue = hotelRoomsRes.data.data;
            } else {
              let error = getErrorMessage(hotelRoomsRes);
              //  this.showAlert(error);
              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid hotel obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in getHotelRooms",
          err.toString(),
          "getHotelRooms",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getSurchargeTypes() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getSurchargeTypes");

        retValue = [
          {
            name: this.$t("surchargeNew.breakfast"),
            value: SURCHARGE_TYPES.BREAK_FAST_PER_PAX,
          },

          {
            name: this.$t("surchargeNew.earlyCheckin"),
            value: SURCHARGE_TYPES.EARLY_CHECKIN,
          },
          {
            name: this.$t("surchargeNew.earlyCheckout"),
            value: SURCHARGE_TYPES.LATE_CHECKOUT,
          },
          {
            name: this.$t("surchargeNew.roomService"),
            value: SURCHARGE_TYPES.ROOM_SERVICE,
          },
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in getSurchargeTypes",
          err.toString(),
          "getSurchargeTypes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async setSurcharge(pSelSurcharge) {
      try {
        if (BaseConfiguration.isDebug) console.log("setSurcharge");

        if (pSelSurcharge) {
          pSelSurcharge = JSON.parse(JSON.stringify(pSelSurcharge));

          if (pSelSurcharge && pSelSurcharge.room) {
            let ratePlanRes = await this.getRatePlan(
              this.hotelObj.hotelid,
              pSelSurcharge.room
            );

            if (ratePlanRes && ratePlanRes.list) {
              this.lsRatePlans = ratePlanRes.list;
            }
          } else {
            this.lsRatePlans = [];
          }

          this.lsRatePlans.unshift({
            id: null,
            name: DEFAULT_DROPDOWN_STATUS.ALL,
          });

          this.surcharge = {
            surchargeId: pSelSurcharge.surchargeid,
            surchargeName: pSelSurcharge.surchargeName,
            ratePlan: this.lsRatePlans.find(
              (plan) =>
                plan.id ==
                (pSelSurcharge.rateplan
                  ? pSelSurcharge.rateplan.id
                  : pSelSurcharge.rateplan)
            ),
            roomObj: this.lsHotelRooms.find(
              (room) =>
                room.roomid ==
                (pSelSurcharge.room
                  ? pSelSurcharge.room.roomid
                  : pSelSurcharge.room)
            ),
            currency: pSelSurcharge.currency
              ? { code: pSelSurcharge.currency }
              : null,
            surchargeValue: pSelSurcharge.surchargevalue,
            surchargeType: this.lsSurchargeTypes.find(
              (type) => type.value == pSelSurcharge.surchargeType
            ),
            pricingType: pSelSurcharge.pricingType,
            stayFrom: pSelSurcharge.stayfrom,
            stayTo: pSelSurcharge.stayto,

            applicableDays: pSelSurcharge.applicableDays,
          };
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in setSurcharge",
          err.toString(),
          "setSurcharge",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async initData() {
      try {
        if (BaseConfiguration.isDebug) console.log("initData");
        let hotelRoomsRes = await this.getHotelRooms();

        if (hotelRoomsRes) {
          this.lsHotelRooms = hotelRoomsRes.list;

          this.lsHotelRooms.unshift({
            roomid: null,
            roomname: DEFAULT_DROPDOWN_STATUS.ALL,
          });
        }
        this.lsSurchargeTypes = this.getSurchargeTypes();

        if (this.selSurcharge) {
          await this.setSurcharge(cloneDeep(this.selSurcharge));
        } else
        {
          this.surcharge.applicableDays= ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"]
        this.setValidity(this.surcharge);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_SURCHARGE_SETUP,
          "error in initData",
          err.toString(),
          "initData",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
  },

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");

      await this.initData();
      this.isLoading=false;
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.C_SURCHARGE_SETUP,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
};
</script>

<style>
.align-curr {
  margin-top: 22px;
}
</style>
